import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationAlert from "react-notification-alert";

import { get_histories_transactions } from "stores/Service/actions";
import { put_markets_exchanges_id_cancel } from "stores/Service/actions";

import HistoriesTransactionsView from "./HistoriesTransactionsViewDesign";

const App = ({nonce}) => {
  const dispatch = useDispatch();
  const ref = useRef();

  const toast = (error) => {
    let message = "";

    if (error.response) {
      const data = error.response.data;
      if (data) {
        if (data.errors) {
          let err1 = data.errors[Object.keys(data.errors)[0]];
          message = err1;
        }
      }
      if (data.status===1) {
        message = `ホットウォレットの残高${data.balance}`
      }


    } else {
      message = error.message;
    }
    dispatch_danger(message);
  };

  const dispatch_info = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-bell-55" />
            <span>{message}</span>
          </div>
        ),
        type: "info",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_danger = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-single-copy-04" />
            <span>{message}</span>
          </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

    const dispatch_get_histories_transactions = (data, page) => {
      dispatch(
        get_histories_transactions({
          data,
          toast,
          page,
        })
      );
    };

    const dispatch_put_markets_exchanges_id_cancel = (data, page) => {
      dispatch(
        put_markets_exchanges_id_cancel({
          data,
          toast:(error)=>{
            toast(error)
          },
          page,
        })
      );
    };

 useEffect(() => {
    dispatch_get_histories_transactions({ page: 1, limit: 10 });
  }, [nonce]);

  return (
    <>
      <div className="notification-container">
        <NotificationAlert ref={ref} />
      </div>

      <HistoriesTransactionsView
        dispatch_info={dispatch_info}
        dispatch_danger={dispatch_danger}
        dispatch_get_histories_transactions={dispatch_get_histories_transactions}
        dispatch_put_markets_exchanges_id_cancel={dispatch_put_markets_exchanges_id_cancel}
      />
    </>
  );
};

export default App;
